import React from "react";
import {AbstractLiveblogElement} from "./AbstractLiveblogElement";
import {PropsParser} from "@webng/validations";
import {LiveblogTeaserThemeConfiguration, LiveblogTeaserWidgetInitialData, SharedThemeConfiguration} from "@webng-types/embedjs";
import {
  LiveblogTeaserWidgetApi,
  LiveblogTeaserWidgetProps,
  LiveblogTeaserWidgetQueryProps,
  liveblogTeaserWidgetQueryPropsParser,
  LiveblogTeaserWidgetTagProps,
  liveblogTeaserWidgetTagPropsParser
} from "./liveblog-teaser/LiveblogTeaserWidgetProps";
import {LiveblogWidgetQueryProps} from "./liveblog/LiveblogWidgetProps";
import {LiveblogTeaserWidget} from "./liveblog-teaser/LiveblogTeaserWidget";
import {
  liveblogTeaserThemeConfigurationSchema,
  parsePartialLiveblogTeaserThemeConfiguration
} from "@webng-types/embedjs/teaser";
import {rawSharedThemeConfigurationSchema} from "@webng-types/embedjs/shared";

const propsParser: PropsParser<LiveblogTeaserWidgetTagProps> = {
  ...liveblogTeaserWidgetTagPropsParser,
};

export class TickarooLiveblogTeaserElement extends AbstractLiveblogElement<LiveblogTeaserThemeConfiguration, LiveblogTeaserWidgetTagProps, LiveblogTeaserWidgetQueryProps, LiveblogTeaserWidgetApi> {
  static get observedAttributes() {
    return [
      ...Object.keys(propsParser).map((x) => x.toLowerCase()),
      ...Object.keys(liveblogTeaserThemeConfigurationSchema).map((x) =>
        x.toLowerCase()
      ),
      ...Object.keys(rawSharedThemeConfigurationSchema.shape).map((x) =>
        x.toLowerCase()
      ),
    ];
  }

  constructor() {
    super(liveblogTeaserWidgetTagPropsParser, liveblogTeaserWidgetQueryPropsParser);
  }

  parseConfigurationProps(metaValues: Record<string, string>, elementAttributes: Record<string, string>): Partial<LiveblogTeaserThemeConfiguration> {
    const metaValuesConfiguration = parsePartialLiveblogTeaserThemeConfiguration(metaValues);
    const elementAttributesConfiguration = parsePartialLiveblogTeaserThemeConfiguration(elementAttributes);
    return Object.assign({}, metaValuesConfiguration, elementAttributesConfiguration);
  }

  useHydrate(props: {
    tagProps: LiveblogTeaserWidgetTagProps;
    queryProps: LiveblogTeaserWidgetQueryProps;
    overrideSharedConfiguration: Partial<SharedThemeConfiguration>;
    overrideConfiguration: Partial<LiveblogTeaserThemeConfiguration>
  }): boolean {
    return !!props.tagProps.initialData?.configuration;
  }



  renderImp(ref: (r: LiveblogTeaserWidgetApi) => void, props: {
    tagProps: LiveblogTeaserWidgetProps;
    queryProps: LiveblogWidgetQueryProps;
    overrideSharedConfiguration: Partial<SharedThemeConfiguration>;
    overrideConfiguration: Partial<LiveblogTeaserThemeConfiguration>
  }): React.ReactNode {
    const finalProps = Object.assign({}, props.tagProps, props.queryProps);
    // The initialData attribute is not cleared when a host swaps liveblogId, so it can belong to another liveblog.
    const initialGame = finalProps.initialData?.gameShowResponse?.game
    if (initialGame && initialGame.ticker_id !== finalProps.liveblogId && initialGame.local_id !== finalProps.liveblogId) {
      finalProps.initialData = {} as LiveblogTeaserWidgetInitialData
    }
    return <LiveblogTeaserWidget key={finalProps.liveblogId} ref={ref} {...finalProps} overrideSharedThemeConfiguration={props.overrideSharedConfiguration} overrideLiveblogTeaserThemeConfiguration={props.overrideConfiguration} />;
  }
}
